import React from 'react';
import Lottie from 'lottie-react';
import ContentContainer from './ContentContainer.jsx';

const lottieContainerStyle = {
	width: 200,
	maxHeight: '30vh',
	margin: '0 auto',
};


const explanationStyle = {
	position: 'relative',
	width: 'auto',
	boxSizing: 'border-box',
	marginTop: '3rem',
	textAlign: 'left',
};

const WelcomeScreen = ({
	animation,
	animationOptions = {},
	children,
	style = {},
}) => {
	return (
		<ContentContainer 
			style={{ justifyContent: 'center', height: '100%', alignItems: 'center', ...style }}
			innerStyle={{ display: 'flex', flexDirection: 'column' }}
		>
			<Lottie animationData={animation} loop={true} style={lottieContainerStyle} {...animationOptions} />
			<article style={explanationStyle}>
				{children}
			</article>
		</ContentContainer>
	);
};

export default WelcomeScreen;